import { render, staticRenderFns } from "./despacho.vue?vue&type=template&id=f46845fa"
import script from "./despacho.vue?vue&type=script&lang=js"
export * from "./despacho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports